const initialState = { 
  loading: false,
  success: null,
  error: null
}

function deleteBannerReducer(state = initialState, action) {
  switch (action.type) {
    case 'DELETE_BANNER_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'DELETE_BANNER_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'DELETE_BANNER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default deleteBannerReducer